import React, { useState } from 'react';
import LoginForms from '../components/LoginForms';

const Login = () => {
  const [accessGranted, setAccessGranted] = useState(false);

  // Función para manejar el envío del formulario de inicio de sesión
  const handleLoginSubmit = (credentials) => {
    if (credentials.username === 'usuario' && credentials.password === 'contraseña') {
      setAccessGranted(true);
    } else {
      alert('Acceso incorrecto. Verifique su nombre de usuario y contraseña.');
    }
  };
 
  return (
    <div className="container">
     <div className='top-bar2'>
            <div className="top-bar">

                <div className="logo">
                   
                        <button className="logo-button">
                            <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
                        </button>
               
                </div>
            </div>
            </div>
  
      <div className='titulo'>
      <h1 className='padrones-titulo'>Consulta Padrones </h1>
        {!accessGranted && <LoginForms onSubmit={handleLoginSubmit} />}
      </div>

      <footer style={{ textAlign: 'center' }}>
        Copyright © Gobierno del Estado de Durango 2024
      </footer>
    </div>
  );
};

export default Login;
